import React from 'react';
import PlatformDetailPage from './PlatformDetailPage';

const BrontoCosmosPage = () => <PlatformDetailPage platformId="brontocosmos" />;

export default BrontoCosmosPage;
